import { VariantIconMarkerLabelSection } from 'components/minute/sidebar/MarkerSidebar/VariantIconMarkerSidebar/VariantIconMarkerLabelSection';
import { VariantIconMarkerStyleSection } from 'components/minute/sidebar/MarkerSidebar/VariantIconMarkerSidebar/VariantIconMarkerStyleSection';
import { IVariantIconV2WorldMarker } from 'react-give-me-map';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IVariantIconV2WorldMarker;
}

export const VariantIconExternalPointSidebar = (props: Props): JSX.Element => {
    return (
        <S_VariantIconExternalPointSidebar className={props.className}>
            <VariantIconMarkerLabelSection marker={props.marker} disableEditText />
            <VariantIconMarkerStyleSection
                marker={props.marker}
                disableIconEdit={Boolean(props.marker.elementData.eventDate)}
            />
        </S_VariantIconExternalPointSidebar>
    );
};

const S_VariantIconExternalPointSidebar = styled.div``;
